import './Spacer.scss';

const Spacer = () => {
  return <div className="Spacer"></div>;
};

export default Spacer;
